export default __webpack_public_path__ + "static/media/genericInsuranceCover.0dfc53ca.png";